import React from 'react'

import { Image } from '../../components'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import {
  ALLOWED_WORDS,
  ContentParser,
  replaceWordInString,
} from '../../utils/helpers'
import {
  contentContainer,
  description,
  mediaContainer,
  mediaImage,
  mothersdayDescription,
} from './ContentMediaSection.module.css'

const ContentMediaSection = ({ lang, slice, url }) => {
  const {
    contentsectionmedia,
    mediacontentheading,
    mediacontentrichtext,
    mediasectionurl,
  } = slice

  const mediaItems = ContentParser(contentsectionmedia, 'media')
  let ctaContent = mediasectionurl
  if (typeof mediasectionurl === 'string') {
    ctaContent = JSON.parse(mediasectionurl)
  }
  const isMothersDay = url === '/mothersday/' || url === '/en/mothersday/'
  return (
    <SectionLayout
      cta={ctaContent}
      extraDescriptionClassName={
        isMothersDay ? mothersdayDescription : description
      }
      extraHeaderClassName={contentContainer}
      heading={mediacontentheading}
      renderedContent={replaceWordInString(
        mediacontentrichtext,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      withCta
      withHeader
    >
      {mediaItems.length > 0 && (
        <div className={mediaContainer}>
          {mediaItems.map((item, index) => {
            return (
              <Image
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                alt={item.alt}
                className={mediaImage}
                src={item.node.localFile.childImageSharp}
              />
            )
          })}
        </div>
      )}
    </SectionLayout>
  )
}

export default ContentMediaSection
